export enum UnitType {
  KG = "KG",
  M3 = "M3"
}
